export default "__VITE_ASSET__KqezArNH__"